// NPM Imports
import React from "react";
import { GlobalUtils } from "../../../utils";

// Component Imports
import ProductConfigurationSelect from "./ProductConfigurationSelect";
import ProductConfigurationSelectUpgrade from "./ProductConfigurationSelectUpgrade";
import { FeatureGating, ReactSelect } from "../../../commonComponents";

// Internal Imports
import { FEATURES } from "../../../constants";

const { readDataFromLocalStorage } = GlobalUtils;

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function (props) {
  const userFeatures = readDataFromLocalStorage("revvsalesUserFeatures");
  if (!userFeatures[FEATURES_NAME.QUOTING_BUNDLE_PRODUCT]) {
    return (
      <div className="addproduct-div-wrapper">
        <span className="addproduct-label">
          {props.title}
          <span className="required-input">*</span>
        </span>
        <ReactSelect
          data-testid="addproduct-product-config-field"
          isSearchable
          valueKey="name"
          onChange={value => props.onSelectChange("productConfig", value)}
          options={props.optionData.filter(options => options !== "Bundle")}
          value={props.productValue}
          data-test="productconfiguration-select"
        />
      </div>
    );
  }
  return (
    <FeatureGating
      name={FEATURES_NAME.QUOTING_BUNDLE_PRODUCT}
      counterFlag={props.teammates}
      altComponent={
        <ProductConfigurationSelectUpgrade
          featureName={FEATURES_NAME.QUOTING_BUNDLE_PRODUCT}
          {...props}
        />
      }>
      <ProductConfigurationSelect {...props} />
    </FeatureGating>
  );
}
